import React from "react";
// ANT DESIGN COMPONENTS
import { Breadcrumb } from "antd";
// NAVIGATION
import { useNavigate } from "react-router-dom";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";

function BanksLiftsPositionsBreadcrumb() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");
  const navigate = useNavigate();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const navigateToBanks = () => {
    navigate({
      pathname: "/edge-management/banks",
    });
  };

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Breadcrumb className="">
      <Breadcrumb.Item>{t("header.edgeManagement")}</Breadcrumb.Item>
      <Breadcrumb.Item className="generalStyles__breadcrumbItemInactive" onClick={navigateToBanks}>
        Banks
      </Breadcrumb.Item>
      <Breadcrumb.Item className="generalStyles__breadcrumbItem">
        {t("general.liftsPositions")}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
}

export default BanksLiftsPositionsBreadcrumb;
